import apiClient, { unwrapData } from "./apiClient";

export async function getSettingsData(options = {}) {
  const response = await apiClient.get("/api/settings", options);
  return unwrapData(response);
}

export async function saveSettingsData(payload = {}, options = {}) {
  const response = await apiClient.patch("/api/settings", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function resetSettingsData(options = {}) {
  const response = await apiClient.post("/api/settings/reset", {
    ...options,
    body: {},
  });

  return unwrapData(response);
}

export async function getBillingSettings(options = {}) {
  const response = await apiClient.get("/api/settings/billing", options);
  return unwrapData(response);
}

export async function getSubscriptionSettings(options = {}) {
  const response = await apiClient.get("/api/settings/billing/subscription", options);
  return unwrapData(response);
}

export async function createRechargeCheckout(payload = {}, options = {}) {
  const response = await apiClient.post("/api/settings/billing/recharge", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function createUpgradeCheckout(payload = {}, options = {}) {
  const response = await apiClient.post("/api/settings/billing/upgrade", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}
